import _ from 'underscore'
import Collection from './collection'
import ClickableImageRegion from './clickable_image_region'

const DEFAULT_NAME_REGEX = /^Region (\d+)$/

export default class ClickableImageRegions extends Collection {
  get model () { return ClickableImageRegion }

  isValueCorrect (value) {
    // 'correct' is on its way to being deprecated. 'correct_response' will be the non-deprecated version (as of March 2019)
    return this.collidableRegions(this).some(region => (region.get('correct') || region.get('correct_response')) && region.contains(value))
  }

  /*
   * first, try to move the region to a valid position
   * by resolving any overlaps. Then, check to make sure
   * it hasn't been moved on top of another region or
   * outside the bounds of the container image
   */
  addValid (region) {
    region.resolveOverlaps(this)

    const invalid = region.outsideContainer() || this.collidableRegions(region).some(r => region.overlaps(r))

    if (!invalid) { this.add(region) }
  }

  /*
   * Regions to check for overlap.
   * Filter out region that matches the
   * passed in one.
   * Filter out regions that have been
   * marked for deletion on the server
   */
  collidableRegions (region) {
    const regions = this.filter(r => (region !== r) && (region.get('_destroy') !== 1) && (r.get('_destroy') !== 1))

    return new ClickableImageRegions(regions)
  }

  highestResult () {
    return _.max(this.pluck('results_count'))
  }

  hasAlphaNumericKeyword () {
    return this.any(option => option.isKeywordAlphaNumeric())
  }

  hasCorrect () {
    // 'correct' is on its way to being deprecated. 'correct_response' will be the non-deprecated version (as of March 2019)
    return this.any(option => option.get('correct') || option.get('correct_response'))
  }

  getNextName () {
    let length = 0
    let maxRegionNumber = 0
    this.each(function (region) {
      if (!region.isOtherRegion()) {
        length += 1

        const match = DEFAULT_NAME_REGEX.exec(region.getName())
        if (match) {
          maxRegionNumber = Math.max(maxRegionNumber, parseInt(match[1]))
        }
      }
    })

    const newNumber = Math.max(length, maxRegionNumber) + 1
    return `Region ${newNumber}`
  }
}
